import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Card, Link, MenuList } from '@mui/material';
import StyledSidebarMenuItem from '../styled/SidebarMenuItem';
import { useAppSelector } from '../../redux/hooks';
import {
    sidebarNavigationAction,
    SidebarNavigationState,
} from '../../redux/slices/sidebarNavigation';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

const SidebarNavigation: React.FC<any> = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const currentPath = window.location.pathname;
    const sidebarItems = props.sidebarItems;
    const { t } = useTranslation();

    const navigationState: SidebarNavigationState = useAppSelector(
        (state) => state.sidebarNavigation
    );

    const location = useLocation();

    useEffect(() => {
        dispatch(sidebarNavigationAction.setSelectedMenu(currentPath));
    }, [location]);

    const handleTabClick = (navItem) => {
        switch (navItem.type) {
            case 'PAGE':
                window.location.replace(navItem.url);
                break;
            default:
                navigate(navItem.url);
        }
    };

    return (
        <>
            <Card>
                <MenuList>
                    {sidebarItems.items.map((navItem) => (
                        <Box key={navItem.id}>
                            {!navItem.showOnlyOnMobile && (
                                <StyledSidebarMenuItem
                                    onClick={handleTabClick.bind(this, navItem)}
                                    selected={
                                        navItem.url ==
                                        navigationState.selectedMenu
                                    }
                                >
                                    {t(navItem.title)}
                                </StyledSidebarMenuItem>
                            )}
                        </Box>
                    ))}
                </MenuList>
            </Card>
        </>
    );
};

export default React.memo(SidebarNavigation);
